import React from "react";
import BG from '../assets/svg/myaccount-bg.svg'
import Logo from '../assets/logo.svg'
import successreset from "../assets/svg/8666656_check_circle_icon.svg"
import CopyrightFooter from '../components/CopyrightFooter'

const Afcrnewpass = (props) => {

    return (
        <>
            <div style={{ backgroundImage: `url(${BG})` }} className="bg-cover bg-top bg-no-repeat flex items-center flex-col min-h-screen py-5 justify-center">
                {props.showWelcome && <h2 className="text-xle font-bold mb-1">Welcome to</h2>}
                <img src={Logo} alt="Viewpro" />
                <div className="bg-white w-fit px-4 py-10 mb-9 mt-13  rounded-md flex flex-col items-center ">
                    {props.children}

                    <div className="my-6  w-fit flex justify-center text-center font-semibold text-3xl text-primary"><img  className="mx-4 h-10" src={successreset}/>Password reset Successfully.</div>
                   <div className="mx-10 text-xl text-center ">Awesome. you've sucessfully updated your password</div>
                    <div className="my-2 text-lg text-center ">Now you are login again</div>
                    <div className=" mt-6">
                        <button to="/" type="submit" className="bg-primary hover:bg-primary-dark border-primary text-white font-semibold  text-base py-1.5 px-8 rounded-full inline-block border-2  active:border-3 disabled:opacity-50 focus:outline-none w-fit mb-2">
                        <a href="/#/login/">Return to login</a>
                        </button>
                    </div>
                </div>
            </div>
            <CopyrightFooter fixedBottom={true} />
        </>
    )
}

export default Afcrnewpass
